export default __webpack_public_path__ + "static/media/BCA19.e03aa500.jpg";